export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6122.1e0baff9.jpg";